import { BCMSStateManagerCRUD, BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes, { Account, PositivePayCheckFile } from "model";
import TASPositivePayCreateTemplatePage, { getDefaultData, getDefaultUI } from "components/pages/TASPositivePayCreateTemplatePage";
import CaptureNotShownView from "components/shared/views/CaptureNotShownView";

/**
 * @name CapturePositivePayImportChecksFileChosen
 * @returns {React.Component}
 * @description A capture in the "Positive Pay - Import Checks" capture group.
 */
export default function CapturePositivePayImportChecksFileChosen(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;
    const hasBusinessAccounts = Account.hasBusinessAccounts(branding);

    if(!hasBusinessAccounts) {
        const message = Account.businessOnlyBrandingErrorMessage;
        return <CaptureNotShownView message={ message }/>;
    }

    const data = BCMSStateManagerCRUD.init( getDefaultData())
    .update([ "checkTemplate", "positivePayCheckFile" ], PositivePayCheckFile.initByID("0"))
    .submit();
    
    const ui = BCMSStateManagerCRUD.init( getDefaultUI(data.checkTemplate))
    .update([ "checkTemplate", "showFilePreview", "isActive" ], true)
    .submit();

    return <TASPositivePayCreateTemplatePage data={ data } ui={ ui } />;
}